import { jwtDecode } from 'jwt-decode';
import { getEncryptedCookies } from './cookies';
import useUserStore from '@/store/zustand/decode-zustand';

export const getToken = () => {
  return useUserStore.getState().token;
};

export const getEntidad = () => {
  let serialized = localStorage.getItem('data-User');

  if (serialized === null) {
    return undefined;
  }
  serialized = JSON.parse(serialized);

  return serialized.state.entidadSeleccionada;
};

export const actions = () => {
  // Cookie ausente, expirada o corrupta (p. ej. encriptada con otra key o vacía):
  // devolver null para que hasPermission redirija a sign-in en vez de romper el render.
  try {
    return JSON.parse(getEncryptedCookies('permisos'));
  } catch {
    return null;
  }
};

export const hasPermission = (nameAction) => {
  const token = getToken();
  if (!token) return false;

  const decoded = jwtDecode(token);
  const action = actions();
  if (!action) {
    window.location.replace('/sign-in');
		return
  }
  const actionValue = action[nameAction]; // DocumentosJurEditar
  //const acciones = useUserStore((state)=>state.entidadSeleccionada)
  const acciones = useUserStore.getState().entidadSeleccionada;
  // La entidad seleccionada puede no estar cargada todavia, o venir sin permisos
  const { permisos } = acciones ?? {};

  if (actionValue && permisos) {
    return permisos.includes(actionValue);
  } else {
    // Si el nameAction no se encuentra en action, devolver falso
    return false;
  }
};
